var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Collection from '../collections/Collection';
export default class EventHandler {
    constructor() {
        this.registeredHandlers = new Collection();
        this.isSuspended = false;
    }
    addHandler(handler, filter) {
        this.registeredHandlers.push({ handler: handler, filter: filter, isAsync: false });
    }
    addAsyncHandler(handler, filter) {
        this.registeredHandlers.push({ asyncHandler: handler, filter: filter, isAsync: true });
    }
    removeHandler(handler) {
        this.registeredHandlers.removeWhere(r => r.handler === handler);
    }
    removeAsyncHandler(handler) {
        this.registeredHandlers.removeWhere(r => r.asyncHandler === handler);
    }
    fire(sender, eventArgs) {
        if (this.isSuspended) {
            return undefined;
        }
        let result;
        const handlersToFire = this.getFilteredHandlers(eventArgs).where(h => !h.isAsync);
        for (const registeredHandler of handlersToFire) {
            result = registeredHandler.handler(sender, eventArgs);
            if (eventArgs.cancel) {
                break;
            }
        }
        return result;
    }
    fireAsync(sender, eventArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isSuspended) {
                return undefined;
            }
            let result;
            for (const registeredHandler of this.getFilteredHandlers(eventArgs)) {
                if (registeredHandler.isAsync) {
                    result = yield registeredHandler.asyncHandler(sender, eventArgs);
                }
                else {
                    result = registeredHandler.handler(sender, eventArgs);
                }
                if (eventArgs.cancel) {
                    break;
                }
            }
            return result;
        });
    }
    clone() {
        const clone = new EventHandler();
        clone.isSuspended = this.isSuspended;
        clone.registeredHandlers = new Collection(this.registeredHandlers);
        return clone;
    }
    getFilteredHandlers(eventArgs) {
        return this.registeredHandlers
            .reversed().where(r => { var _a, _b; return (_b = (_a = r.filter) === null || _a === void 0 ? void 0 : _a.call(r, eventArgs)) !== null && _b !== void 0 ? _b : true; });
    }
}
//# sourceMappingURL=EventHandler.js.map